import { render, staticRenderFns } from "./UITextField.vue?vue&type=template&id=82311e4c&"
import script from "./UITextField.vue?vue&type=script&lang=ts&"
export * from "./UITextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports